import { parse, format, isValid } from 'date-fns';
import {
  PricingRule,
  TimeSlot,
} from 'views/plugins/tours/page/booking_details/pricing-rules/types';

export const convertTo24Hour = (time: string): string => {
  const trimmed = time.trim();
  const referenceDate = new Date(0);

  const formats = [
    'h:mm a', // 3:00 pm
    'h:mma', // 3:00pm / 3:00PM
    'H:mm', // 15:00
  ];

  for (const fmt of formats) {
    const parsed = parse(trimmed, fmt, referenceDate);
    if (isValid(parsed)) {
      return format(parsed, 'HH:mm');
    }
  }

  return trimmed;
};

export const normalizeTime = (time: string): string => {
  return convertTo24Hour(time);
};

export const createPricingRulesMap = (
  timeSlots: TimeSlot[]
): Map<string, PricingRule> => {
  const rulesMap = new Map<string, PricingRule>();

  timeSlots.forEach((slot) => {
    if (slot.pricing_rule && slot.pricing_rule.message) {
      const normalizedTime = normalizeTime(slot.time);
      rulesMap.set(normalizedTime, slot.pricing_rule);
    }
  });

  return rulesMap;
};

export const hasSpecialPricing = (
  time: string,
  pricingRules: Map<string, PricingRule> | null | undefined
): boolean => {
  if (!pricingRules || pricingRules.size === 0) {
    return false;
  }
  const normalizedTime = normalizeTime(time);
  return pricingRules.has(normalizedTime);
};

export const getPricingRule = (
  time: string,
  pricingRules: Map<string, PricingRule> | null | undefined
): PricingRule | undefined => {
  if (!pricingRules || pricingRules.size === 0) {
    return undefined;
  }
  const normalizedTime = normalizeTime(time);
  return pricingRules.get(normalizedTime);
};
